import { ReactNode, memo } from 'react'
import { Icon20 } from 'builder/components/Icon'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { UploadModalContainer, DesktopClose as Close, UploadContainer } from '../styles'

type Props = {
  onClose: () => void
  children: ReactNode
}

const FileUploadContainer = (props: Props) => {
  const { onClose, children } = props
  const CloseIcon = Icon20.Close

  const resumeValidationStatus = useTypedSelector(
    state => state.resumeEditor.prefillResumeSection.resumeValidationStatus,
  )

  return (
    <UploadModalContainer {...{ resumeValidationStatus }}>
      <Close onClick={onClose}>
        <CloseIcon />
      </Close>
      <UploadContainer {...{ resumeValidationStatus }}>{children}</UploadContainer>
    </UploadModalContainer>
  )
}

export default memo(FileUploadContainer)
